import React, { useEffect } from 'react'
import globalStyles from '../../../global.less'
import styles from './index.less'
import { setTitleDesc } from '../../../../utils/tools'

const getSty = (str: string) => styles[str]
const fonSizeBold = (str: string, cla?: string) => (
  <span className={`${getSty('KeyPoint')} ${cla ? styles[cla] : ''}`}>
    {str}
  </span>
)
const fontBoldUnderline = (str: string) => (
  <span className={`${getSty('KeyPoint')} ${getSty('underline')}`}>{str}</span>
)
export default function ProtocolZHCN() {
  useEffect(() => {
    setTitleDesc('Xiaomi Channel', '小米分销通')
  }, [])

  return (
    <div className={`${globalStyles['container']} ${getSty('protocol-zh-tw')}`}>
      <h2 className={getSty('title-h2')}>小米分銷通_T&C</h2>
      <p className={getSty('explain-title')}>小米分銷通平台</p>
      <p className={getSty('explain-title')}>條款與細則 </p>
      <h5 className={getSty('explain')}>
        請仔細閱讀條款和條件，並特別注意粗體大寫的條文。
      </h5>
      <p className={getSty('explain')}>
        本文件包含買方使用小米供應實體（定義見下文）擁有、運營、品牌化和提供的小米分銷通平台及其功能與賣方達成交易、諮詢和處理交易信息的一般條款和條件。
      </p>
      <p className={getSty('explain')}>
        本條款及細則由用戶與小米供應實體訂立。
      </p>
      <div className={getSty('item-box')}>
        <span>定義</span>
        <p className={getSty('title-explain')}>
          為使各方完全理解並接受本條款與細則所載之條款與條件，下列用語（無論單數或複數）應具有以下所指明之含義：
        </p>
        <ol>
          <li>
            {fonSizeBold('帳戶')}
             的定義在「小米分銷通平台註冊與登入」條款中約定。
          </li>
          <li>
            {fonSizeBold('關係企業')}
             就小米供應實體而言，指任何小米供應實體直接或間接擁有或控制的其他個體、或任何擁有或控制小米供應實體的其他個體，或與小米供應實體處於同一個體控制下之任何其他個體。部分功能可能由小米供應實體之關係企業提供支援。
          </li>
          <li>
            {fonSizeBold('機密資訊')}
             指（1）透過小米分銷通平台創建、張貼、上傳或傳輸之任何資訊或數據；及（2）與小米分銷通平台之存在、設計、布局、架構、功能、內容等相關之任何資訊或數據，包括本條款與條件（T&C）之存在及條款。
          </li>
          <li>
            {fonSizeBold('小米上傳之內容')}
             的定義在「小米供應實體上傳之內容」條款中約定。
          </li>
          <li>
            {fonSizeBold('控制')}
             指直接或間接擁有指示或促使他人指示某一實體之管理與政策方向之權力，無論是透過持有表決證券所有權、合約權益或其他方式達成。
          </li>
          <li>
            {fonSizeBold('設備')} 指由小米供應實體及 / 或其直接與間接關係企業及
            / 或小米集團之任何其他成員製造及 / 或分銷並標有Mi, Xiaomi, Redmi,
            等品牌、商標、標籤、標誌或標示之任何產品。
          </li>
          <li>{fonSizeBold('功能')} 指「功能」條款中列舉之各項功能。</li>

          <li>
            {fonSizeBold('法律')}
             指任何及所有成文法、法律、法令、規例、規則、法典、憲法、條約、普通法、政府命令或任何政府當局之其他法律要求或規則。
          </li>

          <li>
            {fonSizeBold('買方')}
             指於小米分銷通平台購買設備之客戶，通常包括分銷商及獨立零售商。由於小米分銷通平台之登入與存取係由買方指定及授權之員工代表買方進行，因此本條款與條件中提及之「買方」應理解為亦包括其員工。
          </li>
          <li>
            {fonSizeBold('人員')}
             指用戶（包括買方或賣方）僱用或委任的員工、代表、代理人、分包商或其他第三方。
          </li>
          <li>
            {fonSizeBold('賣方')}
             指使用小米分銷通平台向買方銷售設備之賣方，包括第三方供應商；若買方為零售商，則通常指分銷商。小米當地實體亦可能為賣方。
          </li>
          <li>
            {fonSizeBold('第三方供應商')}
             指使用小米分銷通平台向買方銷售設備之賣方，但不包括小米供應實體。
          </li>
          <li>
            {fonSizeBold('條款與條件（T&C）')}
             指規範用戶與小米供應實體間關係之本合約。
          </li>
          <li>
            {fonSizeBold('用戶')}
             指使用小米分銷通平台之功能從事設備買賣之人士，包括買方及賣方。
          </li>
          <li>
            {fonSizeBold('小米分銷通平台')}
             指小米分銷通平台之網站、行動網站及行動應用程式（簡稱「平台」），買方可透過該平台存取及使用各項功能。
          </li>
          <li>
            {fonSizeBold('小米供應實體')} 指小米集團中可能供應設備之任何實體。
          </li>
        </ol>
      </div>
      <div className={getSty('item-box')}>
        <span>功能</span>
        <p className={getSty('title-explain')}>
          小米分銷通平台具備便利買方設備採購活動之功能，包括但不限於：
        </p>
        <ol>
          <li>
            {fonSizeBold('買方資料檔')}
            <p>
              透過此功能，買方可（1）於「帳戶」項下查詢其基本資訊，如營業登記資訊、稅務資訊、股東資訊、送貨地址資訊、銀行帳戶資訊及相關附件；及（2）於「帳戶」項下查閱買方與其對應之小米供應實體所簽署之協議
              / 合約。
            </p>
          </li>
          <li>
            {fonSizeBold('財務資訊檢視 ')}
            <p className={`${styles['mb-8']} ${styles['mt-8']}`}>
              透過此功能，買方可檢視其使用之信用憑證。
            </p>
            <p className={`${styles['mb-8']} ${styles['mt-8']}`}>
              {fonSizeBold(
                '為免疑義，本節所顯示之數據與資訊僅供調帳參考，若買方對所顯示之數據與資訊有任何疑問，可聯繫其對應賣方指定之銷售經理。'
              )}
            </p>
          </li>
          <li>
            {fonSizeBold('採購訂單管理 ')}
            <p>
              透過此功能，買方可（1）查詢前三（3）個月內所下達之採購訂單狀況；（2）查詢前三（3）個月內採購訂單之送貨單；及（3）向其對應之賣方下達採購訂單，使用小米分銷通平台顯示之表格完成並提交線上採購訂單以購買設備。
            </p>
            <p>
              下達採購訂單時，買方應填寫所有所需資訊。採購訂單於買方提交至其對應之賣方時被認爲已送達，並於賣方負責設備銷售之第一位員工收到時視為收訖。
            </p>
            <p>
              若採購訂單遭賣方拒絕，買方會收到書面通知，或對應賣方指定之銷售經理會聯繫買方。
            </p>
            <p>
              若買方於小米分銷通平台下單購買小米當地實體銷售之設備，且小米當地實體已接受該訂單，此將構成買方與小米當地實體之間直接建立之合約關係。
            </p>
            <p>
              另一方面，若買方於小米分銷通平台下單購買第三方供應商銷售之設備，且該第三方供應商已接受該訂單，此將構成買方與該第三方供應商之間直接建立之合約關係。若合約係直接由買方與第三方供應商締結，小米當地實體並非該合約或買方與第三方供應商間任何其他協議之當事方，且不承擔與該等協議相關之任何義務。該等合約或任何其他協議之當事方應全權負責彼此間之協議、設備列表、購買保證等事項。
            </p>
            <p>
              採購訂單可於賣方接受前由買方撤銷。若採購訂單僅部分履行或完全未履行，買方或賣方均可啟動採購訂單終止程序。
              {fonSizeBold(
                '若賣方啟動終止程序，將發送電子郵件至買方，買方可接受或拒絕終止採購訂單，若買方未於三（3）個工作天內回覆該電子郵件，相關採購訂單將視為經雙方協議終止。 '
              )}
            </p>
            <p>
              若買方資訊變更影響採購訂單之履行，小米供應實體有權合理暫停採購訂單之履行或採取其他相應適當措施，且不承擔任何額外費用或責任。
            </p>
          </li>
          <div className={styles['mg-42']}>
            {fonSizeBold(
              '為免疑義，買方同意，小米分銷通平台採購訂單表格所載之條款與條件為其與對應之小米供應實體所協商之內容，且若其透過此功能下達採購訂單，即表示接受該等採購訂單之條款與條件並受其拘束。'
            )}
          </div>
          <li>
            {fonSizeBold('配銷管理')}
            <p>
              透過此功能，買方可填寫並管理其標明設備之接收、銷售或退回之配銷訂單。
            </p>
          </li>
          <li>
            {fonSizeBold('訊息接收')}
            <p>透過此功能，買方可接收來自賣方或小米供應實體之訊息。</p>
          </li>
          <li>
            {fonSizeBold('其他功能')}
            <p>買方亦可根據上述功能查詢某些綜合業務數據。</p>
            <div className={styles['mg-42']}>
              買方得自由決定存取及使用小米分銷通平台及其功能，且該存取與使用為免費。
            </div>
          </li>
        </ol>
      </div>
      <div className={getSty('item-box')}>
        <span>條款與條件之接受</span>
        <ol>
          <li>
            於使用功能前，用戶須仔細閱讀本條款與條件，充分理解其所有章節，包括
            {fonSizeBold(
              ' 免責聲明、責任限制、用戶責任及管轄法律與管轄權等條款'
            )}
            , 並自行決定接受或拒絕本條款與條件。
          </li>
          <li>
            透過註冊、登入、使用功能或其他行為，用戶確認已閱讀並充分理解本條款與條件，並同意接受其拘束。若用戶未遵守小米分銷通平台之條款及
            / 或政策，小米供應實體有權暫停或停止提供功能予該用戶。
          </li>
          <li>
            {fontBoldUnderline('隱私政策')}及小米分銷通平台上可供用戶查閱之
            {fontBoldUnderline('其他具拘束力文件')}
            ，均為本條款與條件之補充協議，具有相同法律適用性與效力。若用戶使用功能，即視為默示接受本條款與條件及上述補充協議。
          </li>
          <li>
            小米供應實體於必要時得隨時修改本條款與條件及任何補充協議。用戶接受本條款與條件，即同意接受所有該條款與條件内的約束，包括接受小米供應實體保留隨時修改本條款與條件及其補充協議之權利，不論是否事前通知用戶。用戶可隨時開啟小米分銷通平台查閱最新條款與條件及其補充協議，該等內容自發布時生效。若用戶無法接受小米供應實體修改之內容，應自行決定停止使用功能。用戶繼續使用功能，即同意接受並受修改後之條款與條件及其補充協議拘束。
          </li>
          <li>
            本條款與條件及其補充協議、相關買賣協議及本條款與條件提及之其他文件，構成用戶與對應小米供應實體間就使用小米分銷通平台及功能之具法律拘束力協議。若用戶不接受本條款與條件、其補充協議及
            /
            或其中發布或提及之任何其他通知、法律聲明、資訊，則不得申請帳戶、註冊、登入或使用小米分銷通平台或相關功能，此由用戶自行決定。
          </li>
          <li>
            小米供應實體保留自行決定隨時變更小米分銷通平台之圖形介面、功能、平台上可用內容及其組織，以及小米分銷通平台功能與管理之任何其他特性之權利（縱使在用戶註冊後亦同），必要時將向用戶傳達相關指示，但無義務為之。小米分銷通平台之任何修訂版本、新功能之引入及現有功能之更新或其他變更，均受本條款與條件及其補充協議規範。
          </li>
        </ol>
      </div>
      <div className={getSty('item-box')}>
        <span>小米分銷通平台註冊與登入</span>
        <ol>
          <li>
            為使用小米分銷通平台及其功能，用戶可向其對應之小米供應實體發送正式請求，申請並取得一個或多個小米分銷通平台帳戶（下稱「帳戶」），該帳戶對應部分或全部功能，並由用戶指定及授權之員工操作。為此，用戶須列明獲授權存取帳戶之員工全名及其電子郵件及
            /
            或其他所需資訊。帳戶一經啟用，對應之小米供應實體將向用戶提供帳戶及其初始密碼。用戶首次存取帳戶時，須變更初始密碼。
          </li>
          <li>
            為登入小米分銷通平台並使用功能，用戶及 /
            或其授權員工須輸入登入憑證（電子郵件地址及設定之密碼等）。帳戶僅得由用戶指定及授權之員工使用。
          </li>
          <li>
            用戶於此承諾並保證負責其帳戶資訊及密碼之安全，並對其帳戶下之活動承擔法律責任。任何未經授權之人透過用戶帳戶非法登入及存取小米分銷通平台，均由用戶全權負責，且用戶須彌補小米供應實體及其關係企業因該等存取所生之任何損失、損害及對其他受影響第三方之賠償。
          </li>
          <li>
            用戶亦理解並確認同意，小米供應實體保留隨時臨時或永久變更、更新、暫停、限制、終止或撤銷帳戶之權利，無需事前通知，且對因此產生之任何損失或損害不承擔任何責任。
          </li>
          <li>
            {fonSizeBold('隱私政策。')}
            小米供應實體得為溝通及發展雙方業務關係、遵守法律義務及落實本條款與條件之一般效力，收集並處理用戶及
            /
            或其人員之個人資料。該等個人資料將依《隱私政策》收集及處理，用戶可於申請帳戶前、首次登入小米分銷通平台時及
            / 或平台首頁底部查閱該政策。
          </li>
          <div className={styles['text-indent-2']}>
            {fonSizeBold(
              '用戶接受《隱私政策》，即確認同意小米供應實體或其關係企業收集及處理其所提供之個人資料。'
            )}
          </div>
        </ol>
      </div>
      <div className={getSty('item-box')}>
        <span>帳戶註銷與關閉</span>
        <ol>
          <li>
            若用戶欲停用或註銷帳戶，可向其對應之小米供應實體指定的聯絡人發送書面通知。
          </li>
          <li>
            若用戶違反本條款與條件、其補充協議及 /
            或適用法律規定，小米供應實體有權隨時不經通知暫停或關閉相關帳戶。
          </li>
        </ol>
      </div>
      <div className={getSty('item-box')}>
        <span className={styles['line-1-4']}>買方與賣方之合約關係</span>
        <ol>
          <li>
            買方與其對應賣方間之買賣合約關係，應受本條款與條件、其補充協議、買賣協議及雙方簽署之採購訂單（包括買方透過小米分銷通平台下達且經對應賣方同意之線上採購訂單）規範。
          </li>
          <li>
            買方確認並同意，透過小米分銷通平台下達且經對應賣方電子核准之線上採購訂單，符合該等協議、合約及採購訂單須以書面為之之任何法律要求，且該等採購訂單具有完整效力，買方將全權履行。
          </li>
          <li>
            若發生衝突，文件效力之優先順序如下（由高至低）：本條款與條件及其修正與補充協議、買賣協議、授權書、採購訂單。惟若衝突涉及交貨、服務與支援及地區定義，則以個別採購訂單所載之條款為準。
          </li>
        </ol>
      </div>
      <div className={getSty('item-box')}>
        <span className={styles['line-1-4']}>小米供應實體上傳之內容</span>
        <ol>
          <li>
            就小米分銷通平台之部分欄位，小米供應實體得依用戶提供之文件張貼及上傳與用戶相關之內容（「小米上傳之內容」）。對於小米上傳之內容（如用戶註冊資訊），用戶應檢查、確認並確保其真實性、合法性、準確性及有效性。
          </li>
          <li>
            若小米上傳之內容有任何不準確或變更，用戶應及時通知對應之小米供應實體，否則用戶須承擔由此產生之一切風險與損失。
          </li>
        </ol>
      </div>
      <div className={getSty('item-box')}>
        <span>用戶之聲明與保證</span>
        <ol>
          <li>
            用戶聲明、保證並同意：(1)
            其有充分權力與授權接受本條款與條件及其補充協議、給予許可與授權以及履行本條款與細則下之義務；及
            (2)
            其對小米分銷通平台及功能之存取與使用僅用於商業目的，並遵守本條款與條件及其補充協議的條款。
          </li>
          <li>
            作為於小米分銷通平台註冊流程之一部分，用戶須提供或會被要求提供其實體或業務之資訊或資料，以存取及使用任何功能或帳戶。用戶聲明、保證並同意：(1)
            無論於註冊流程前、期間或其後持續使用小米分銷通平台或功能過程中提交之該等資訊與資料，均為真實、準確、最新及完整，而非虛假、誤導或欺騙性質；及
            (2)
            其將維護並即時修正所有資訊與資料，以維持其真實性、準確性、最新性及完整性。
          </li>
          <li>
            用戶聲明、保證並同意，使用小米分銷通平台及功能時，將本於誠信並遵守所有適用法律（包括用戶與小米供應實體所在地之法律、微軟之用戶協議與政策及本條款與條件及其補充協議），並對其帳戶下之活動承擔全部責任，且不將小米分銷通平台用於欺詐。
          </li>
          <li>
            用戶確認，與他人共用帳戶或允許其企業實體以外之用戶使用帳戶，可能對小米供應實體及其關係企業造成不可彌補之損害，並聲明、保證並同意妥善保管小米分銷通平台之註冊資訊與登入憑證，並對其帳戶下之一切活動負責。
          </li>
          <li>
            用戶聲明、保證並同意，不使用其他用戶之帳戶與密碼，不冒用他人名義創建、上傳或張貼任何資訊。用戶同意，一旦懷疑他人使用其密碼或帳戶，立即以電子郵件通知小米供應實體（電子郵件地址：
            <a href='mailto:robot@xiaomi.com'>robot@xiaomi.com</a>）。
          </li>
          <li>
            用戶聲明、保證並同意，承諾使小米供應實體及其關係企業免受任何因用戶違反小米分銷通平台註冊規則、登入憑證儲存要求與使用規則或用戶之任何其他行為而產生之損害、賠償及
            /
            或處罰；否則，小米供應實體有權暫停帳戶及用戶對小米分銷通平台之存取，且用戶須全權承擔所有法律責任。小米對用戶行為引發之任何索賠或損失不承擔任何責任。
          </li>
        </ol>
      </div>
      <div className={`${getSty('item-box')} ${styles['bold-box']}`}>
        <span>免責聲明 </span>
        <ol>
          <li>
            小米供應實體及其關係企業於下列情形不承擔任何法律責任：
            政府部門或適用法律要求提供用戶資訊。
          </li>
          <div className={styles['disorderly']}>
            用戶行為導致之私人資訊揭露。
          </div>
          <div className={styles['disorderly']}>
            依適用法律（包括用戶及其對應小米供應實體所在地之法律）揭露禁止的資訊。
          </div>
          <div className={styles['disorderly']}>
            因駭客攻擊、病毒入侵、非法或騷擾性內容導致之阻斷、政府管制或任何其他與網路、技術、通訊線路及資訊安全管理相關原因造成之暫停、中斷等情形。
          </div>
          <div className={styles['disorderly']}>
            第三方導致之用戶或任何受影響第三方之損失，諸如通訊線路中斷、技術問題、網路與電腦故障及其他不可抗力事件。
          </div>
          <div className={styles['disorderly']}>
            匿名或透過小米分銷通平台散佈之威脅、誹謗、冒犯性或非法資訊引發之風險。
          </div>
          <div className={styles['disorderly']}>
            用戶因疏忽及 /
            或違反本條款與條件之任何規定導致之損失、索賠、法律訴訟。
          </div>

          <li>
            小米分銷通平台及功能係以「現狀」及「可用狀態」提供，小米供應實體及 /
            或其關係企業不對小米分銷通平台及功能之及時性、安全性與準確性作出任何明示、默示或其他形式之保證，亦不保證小米分銷通平台及功能將滿足用戶需求，或絕不中斷、無錯誤、無病毒或漏洞。
          </li>
          <li>
            小米供應實體及其關係企業將致力確保小米分銷通平台及其功能每日 24
            小時持續可用，但若因任何原因導致小米分銷通平台及 /
            或功能於任何時間或期間無法存取及 /
            或運作，小米供應實體及其關係企業概不承擔責任。系統故障、維護、修復或與小米供應實體及其關係企業意願完全無關之原因或不可抗力事件發生時，小米供應實體及/或其關係企業可能暫停存取小米分銷通平台及
            / 或功能，在此情況下，小米供應實體將盡力通知用戶。
          </li>
          <li>
            於任何情況下，小米供應實體及 /
            或其關係企業均不對任何間接、衍生、懲戒性、附帶、特殊或懲罰性損害（包括因使用小米分銷通平台或功能導致之利潤損失）承擔責任。用戶須自行承擔透過小米分銷通平台或功能使用電腦系統與行動資料庫之所有風險。
          </li>
        </ol>
      </div>
      <div className={`${getSty('item-box')} ${styles['bold-box']}`}>
        <span>責任限制</span>
        <ol>
          <li>
            除非因故意或重大過失，否則小米供應實體不對用戶因使用超出其控制的或其供應商的網絡而產生的服務中斷或故障，承擔責任。
          </li>
          <li>
            此外，若因非可歸責於小米供應實體及其關係企業之原因導致本條款與條件未能得到執行，小米供應實體不對用戶因此產生之損害、損失及費用承擔責任。
          </li>
          <li>小米供應實體不承擔以下責任：</li>
          <div className={styles['disorderly']}>
            非因小米供應實體違反本條款與條件而直接導致之用戶業務機會損失及任何其他損失（縱為間接損失）；
          </div>
          <div className={styles['disorderly']}>
            用戶或第三方非法、錯誤或不當使用小米分銷通平台。
          </div>

          <li>
            若小米供應實體須對違反本條款與條件承擔責任，其責任應以小米供應實體於締結本條款與條件時，基於當時已知情形通常可預期之損害為限。縱有前述規定，該等損害不得超過
            3000新臺幣（或等值當地貨幣）。
          </li>
        </ol>
      </div>
      <div className={getSty('item-box')}>
        <span>用戶責任</span>
        <ol>
          <li>用戶須全部承擔違反以下文件中的義務之責任：</li>
          <div className={styles['disorderly']}>本條款與條件及其補充協議。</div>
          <div className={styles['disorderly']}>
            相關司法管轄區之任何適用法律，包括用戶所在地、用戶存取及使用小米分銷通平台之地區，或其對應小米供應實體所在地之法律。
          </div>
          <div className={`${styles['mt-12']} ${styles['text-indent-2']}`}>
            {fonSizeBold(
              '對於此類違反行為之後果，包括小米供應實體、其關係企業或任何第三方可能招致或遭受之任何損失或損害，小米供應實體及其關係企業對用戶或任何第三方不承擔任何責任。'
            )}
          </div>
          <div
            className={`${styles['mt-12']} ${styles['mb-8']} ${styles['text-indent-2']}`}
          >
            {fonSizeBold(
              '用戶須確保其對應之小米供應實體及其關係企業免於因用戶行為引發之任何索賠或損失承擔責任或義務。'
            )}
          </div>
          <li>用戶不得使用小米分銷通平台或功能從事以下行為或活動：</li>
          <div className={styles['disorderly']}>
            上傳或釋放病毒、蠕蟲或惡意軟體以損害或變更電腦系統或數據。
            未經授權及當事人直接同意且違反適用法律，收集他人資訊或數據（如電子郵件地址）。
          </div>
          <div className={styles['disorderly']}>
            中斷小米分銷通平台網路連線、造成平台流量負載過大，或以其他方式干擾或破壞伺服器及連線。
          </div>
          <div className={styles['disorderly']}>
            未經授權嘗試存取小米分銷通平台、伺服器或連線。
          </div>
          <div className={styles['disorderly']}>
            干擾或破壞其他用戶正常使用功能；
          </div>
          <div className={styles['disorderly']}>
            從事任何違法行為（依適用法律，包括用戶及其對應小米供應實體所在地之法律）。
          </div>

          <div
            className={`${styles['mt-12']} ${styles['mb-12']}  ${styles['text-indent-2']}`}
          >
            {fonSizeBold(
              ' 用戶須對上述行為承擔一切責任，並確保小米供應實體及其關係企業免受損害。'
            )}
          </div>
          <li>
            用戶同意合法、無害地使用小米分銷通平台或功能，並承擔因其使用平台或功能及違反本條款與條件引發之任何訴訟、投訴、損失、損害、責任、費用（包括但不限於律師費），包括第三方索賠。
          </li>
          <p className={`${styles['mb-8']} ${styles['mt-8']}`}>
            小米供應實體及 / 或其關係企業保留抗辯及索賠之專屬權利。
          </p>
          <li>
            未經小米供應實體書面同意，用戶與其對應小米供應實體共同對第三方提起訴訟時，用戶不得單方達成和解。小米供應實體應合理通知用戶該等訴訟或法律行動。
          </li>
        </ol>
      </div>
      <div className={getSty('item-box')}>
        <span>保密條款</span>
        <ol>
          <li>
            用戶及其人員須隨時對機密資訊嚴守秘密，除非事先獲得小米供應實體或其關係企業之書面同意，不得將機密資訊用於除履行或執行本條款和條件及/或與小米分銷通平台和功能有關的其他權利和義務以外的任何目的。
          </li>
          <li>
            用戶須採取嚴格安全措施保護機密資訊，包括但不限於建立機密制度、培訓所有可存取機密資訊之相關人員、與其簽署保密協議，並強調機密資訊之機密性、安全措施及違約責任。
          </li>
          <li>
            未經其對應小米供應實體及 /
            或其關係企業事先書面同意，用戶不得對揭露之任何機密資訊（無論有形或無形）進行逆向工程、解編或拆解，亦不得移除、塗改或損毀小米供應實體及
            /
            或其關係企業揭露之機密資訊原件或副本上之任何版權聲明、商標、標識、文字或圖例或其他所有權聲明。
          </li>
          <li>
            應其對應小米供應實體隨時請求，用戶須：(i)
            將所有機密資訊、包含該等資訊之所有文件或媒體及其副本或摘要，返還予小米供應實體及
            / 或其關係企業；或 (ii)
            銷毀所有包含該等機密資訊之文件或媒體及其副本或摘要，並向小米供應實體提供由用戶授權代表簽署之書面銷毀證明。
          </li>
          <li>用戶須對其人員洩漏機密資訊承擔責任。</li>
          <li>
            用戶亦須遵守與對應小米供應實體簽署之保密協議。若本保密條款與前述保密協議之規定抵觸，以較嚴格之規定為準。
          </li>
        </ol>
      </div>
      <div className={getSty('item-box')}>
        <span>不可抗力</span>
        <ol>
          <li>
            若因不可抗力事件或任何不可預見、無法預料且非當事人所能控制之情形，導致用戶及其對應小米供應實體未能履行或延遲履行義務，雙方不承擔責任。
          </li>
          <li>
            於不可抗力事件發生期間，用戶或其對應小米供應實體之義務履行視為暫停。
          </li>
          <li>
            用戶及其對應小米供應實體將盡其所能採取行動，以尋求解決方案，確保於不可抗力事件持續期間仍能正確履行義務。
          </li>
        </ol>
      </div>
      <div className={getSty('item-box')}>
        <span>期限與終止</span>
        <ol>
          <li>
            本條款與條件於用戶首次同意本條款或首次使用功能時（以較早者為準）生效，並於用戶使用小米分銷通平台及功能期間持續有效，直至依適用法律或本條款與條件終止為止。
          </li>
          <li>
            若用戶違反本條款與條件及 /
            或（包括用戶及小米供應實體所在地之法律）使用小米分銷通平台及功能違反適用法律從事非法行為，小米供應實體有權隨時基於任何原因未經通知終止本條款與條件並註銷用戶帳戶。
          </li>
          <div className={`${styles['mt-8']} ${styles['mb-8']}`}>
            {fonSizeBold(
              '小米供應實體可行使以上權利即使其僅懷疑用戶有上述違反情事。'
            )}
          </div>
          <li>
            不受前述規定限制，若用戶侵犯第三方智慧財產權或收到所有權人或其法律代表之通知，小米供應實體有權終止本條款與條件。
          </li>
          <li>
            本條款與條件終止後，所有帳戶及用戶使用小米分銷通平台與功能之權利亦隨之終止。用戶應瞭解，此意味著小米分銷通平台上與用戶相關之內容可能從小米供應實體或其關係企業之資料庫移除，但不影響此方面之任何法律義務。小米供應實體對終止本條款與條件（包括終止帳戶及移除平台上與用戶相關之內容）不承擔任何責任。
          </li>
        </ol>
      </div>
      <div className={getSty('item-box')}>
        <span>第三方</span>
        <ol>
          <li>
            用戶理解並同意，小米分銷通平臺及其功能可能需要第三方協力廠商的技術支援。用户理解並同意，小米供應實體及其關係企業可能會在接受第三方協力廠商技術或其他支援的過程中，將用戶的部分個人資料提供給這些第三方協力廠商。用戶同意並授權，根據第三方協力廠商服務
            / 軟體的要求，其權利可能會受到一些限制。
          </li>
          <li>
            用戶理解並同意，小米分銷通平臺可能包含指向第三方協力廠商之網站或應用程式的連結。小米供應實體對這些連結的網站或應用程式沒有控制權，因此，小米供應實體對這些網站
            / 應用程式的內容不承擔任何責任。
          </li>
          <li>
            當用戶訪問第三方協力廠商的應用程式、網站和廣告時，適用第三方協力廠商的條款和政策。使用者在使用第三方協力廠商服務時，將承擔所有風險和法律責任。
          </li>
        </ol>
      </div>
      <div className={getSty('item-box')}>
        <span>工業和智慧財產權</span>
        <ol>
          <li>
            小米供應實體及其關係企業聲明其爲小米分銷通平臺、功能和 /
            或小米分銷通平臺上可用內容相關的所有必要智慧財產權的被許可方或所有者。所有商業秘密、商標、圖形或文字及其他標識、商業名稱、服務標記、文字標記、商業名稱、插圖、圖像、標誌、與小米分銷通平臺、功能和
            /
            或小米分銷通平臺上可用內容相關的內容，均受有關商業秘密、商標、版權、作者權利等現行法律以及相關國際條約的保護。
          </li>
          <li>
            除非另有規定，本條款與條件不授予用戶任何與小米分銷通平臺和 /
            或其中可用內容和 / 或材料相關的使用許可。
          </li>
          <li>
            未經授權，以任何形式複製小米分銷通平臺的解釋性文本、內容及其任何功能，將被視為侵犯小米供應實體及其關係企業的工業和智慧財產權。
          </li>
          <li>
            用戶不得出售、租賃、轉讓、發佈或以其他方式對小米分銷通平臺上的可用內容進行商業利用（包括但不限於可能屬於第三方協力廠商財產的內容）。
          </li>
          <li>
            用戶不得訪問小米分銷通平臺、使用其功能並複製其內容以創建類似的網站或應用程式。
          </li>
          <li>
            除非法律或本條款與條件另有明確規定，否則用戶不得以任何方式複製、發佈、下載、更改、翻譯、合併、分解、粘貼或反編譯小米分銷通平臺、其功能及其內容的任何部分。
          </li>
        </ol>
      </div>
      <div className={getSty('item-box')}>
        <span>通知</span>
        <ol>
          <li>
            與小米分銷通平臺及其功能相關的任何通知或其他通信，應以英文書面形式進行，可以通過專人送達、掛號信、傳真或電子郵件發送，並應寄往用戶在小米分銷通平臺上提供的最新通信地址、傳真號碼或電子郵寄地址或用戶以書面形式通知小米的其他位址或詳細資訊。
          </li>
          <li>
            與小米分銷通平臺及其功能相關的任何通知或其他通信，應以書面形式發送至
            <a href='mailto:robot@xiaomi.com'>robot@xiaomi.com</a>{' '}
            或小米供應實體以書面形式通知用戶的其他地址或詳細資訊。
          </li>
          <li>
            用戶同意，小米供應實體以電子方式發送給用戶的所有協議、通知、要求、披露和其他通信，均符合此類通信應以書面形式進行的任何法律要求。
          </li>
        </ol>
      </div>
      <div className={`${getSty('item-box')} ${getSty('bold-box')}`}>
        <span>適用法律和管轄權</span>
        <ol>
          <li>
            本條款與條件受台灣地區法律管轄，不考慮其法律衝突原則，但前提是不與用戶和
            /
            或其相應的小米供應實體所在地區適用的任何強制性規則以及第三方協力廠商授予小米供應實體或其關係企業使用小米分銷通平臺的許可條款和條件相衝突。
          </li>
          <li>
            因本條款與條件引起的或與之相關的任何爭議、糾紛、分歧或索賠，包括其存在、有效性、適用、履行、違約或終止，或與非合同義務相關的任何爭議，均應提交台灣臺北地方法院解決爭議）本協定中的任何內容均不妨礙用戶或相應的小米供應實體在必要時，向任何有管轄權的法院尋求緊急禁令或類似救濟，以執行其在本條款與條件下的權利。
          </li>
        </ol>
      </div>
      <div className={getSty('item-box')}>
        <span>一般條款</span>
        <ol>
          <li>
            如果本條款與條件的任何規定在任何方面被認定為無效、非法或不可執行，其餘規定的有效性、合法性和可執行性不應因此受到任何影響或損害。
          </li>
          <li>
            小米供應實體保留將其在本條款與條件下的任何或所有權利和義務，轉讓或轉移給其任何關聯方、用戶、關係企業或小米集團成員的權利，且無需事先通知用戶。然而，在發生此類變更的情況下，用戶在本條款與條件下的權利不會受到任何不利影響。未經其相應的小米供應實體事先書面同意，用戶不得轉讓其在本條款與條件下的權利和義務。任何違反本條款的行為均無效。
          </li>
          <li>
            本條款與條件，包括其補充協議和本文檔中引用的其他文檔，構成用戶和小米供應實體之間就使用小米分銷通平臺及其功能的最終、完整和排他性協議。
          </li>
          <li>每一段落的標題僅為方便閱讀而設，不具有任何法律或合同義務。</li>
          <li>
            本條款與條件及其補充協議無意也不會創建任何代理、合夥、合資、雇主 -
            雇員或特許經營關係。
          </li>
          <li>
            小米供應實體及其關係企業未能行使本條款與條件下的任何權利，不應構成對該權利的放棄，也不應構成對隨後或類似違約行為的放棄。放棄權利僅在書面作出時才有效。
          </li>
          <li>
            如果小米供應實體翻譯並發佈本條款與條件的其他語言版本，用戶同意該翻譯僅為方便提供，且本條款與條件的英文版本將管轄其對小米分銷通平臺的使用，但適用法律禁止的除外。
          </li>
        </ol>
      </div>
      <footer>最新發佈日期：2024 年 8 月 20 日</footer>
    </div>
  )
}
